export const web = '1200px';
export const tablet = '900px';
export const phone = '600px';
export const phoneSmall = '375px';
